import { Tooltip } from 'react-tooltip';
import { NavLink } from 'react-router-dom';
import ReactDOM from 'react-dom';

const LinkWithTooltip = ({
                             id,
                             tooltip,
                             tooltipIconClass,
                             iconStyle = {},
                             buttonStyle = {},
                             href,
                             linkName,
                             onClick,
                             ariaLabel
                         }) => {
    const sharedStyle = {
        background: 'transparent',
        border: 'none',
        padding: 0,
        boxShadow: 'none',
        lineHeight: '1',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        fontSize: '16px',
        textDecoration: 'none',
        ...buttonStyle,
        ...iconStyle
    };

    const icon = (
        <i
            className={tooltipIconClass}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                margin: 0,
                padding: 0
            }}
        />
    );

    let element;

    if (onClick) {
        // Modal trigger (share/delete)
        element = (
            <button
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    onClick(e, id);
                }}
                aria-label={ariaLabel || tooltip}
                className="btn btn-sm"
                style={sharedStyle}
                data-tooltip-id={`tooltip-${id}`}
                data-tooltip-content={tooltip}
            >
                {icon}
            </button>
        );
    } else if (href) {
        // Navigation (edit), Card icon
        element = (
            <NavLink
                to={{ pathname: href, state: { id, linkName } }}
                aria-label={ariaLabel || tooltip}
                className="btn btn-sm"
                style={sharedStyle}
                data-tooltip-id={`tooltip-${id}`}
                data-tooltip-content={tooltip}
                onKeyDown={(e) => {
                    if (e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        e.target.click();
                    }
                }}
            >
                {icon}
            </NavLink>
        );
    } else {
        // Passive icon (preferences)
        element = (
            <button
                type="button"
                onClick={(e) => e.preventDefault()}
                aria-label={ariaLabel || tooltip}
                className="btn btn-sm"
                style={sharedStyle}
                data-tooltip-id={`tooltip-${id}`}
                data-tooltip-content={tooltip}
            >
                {icon}
            </button>
        );
    }

    const tooltipRoot = document.getElementById('tooltip-root');

    return (
        <div style={{ position: 'relative', display: 'inline-block', zIndex: 1 }}>
            {element}
            {tooltipRoot &&
                ReactDOM.createPortal(
                    <Tooltip
                        id={`tooltip-${id}`}
                        place="top"
                        positionStrategy="fixed"
                    />,
                    tooltipRoot
                )}
        </div>
    );
};

export default LinkWithTooltip;